function annotatorLeganto(options){
// Object to hold local state
    var s = {
        interactionPoint: null
    };

    ///////////////////////////////////////from main.js
    function trim(s) {
        if (typeof String.prototype.trim === 'function') {
            return String.prototype.trim.call(s);
        } else {
            return s.replace(/^[\s\xA0]+|[\s\xA0]+$/g, '');
        }
    }
    function annotationFactory(contextEl, ignoreSelector) {
        return function (ranges) {
            var text = [],
                serializedRanges = [];
    
            for (var i = 0, len = ranges.length; i < len; i++) {
                var r = ranges[i];
                text.push(trim(r.text()));
                serializedRanges.push(r.serialize(contextEl, ignoreSelector));
            }
    
            return {
                quote: text.join(' / '),
                ranges: serializedRanges
            };
        };
    }
    // Local helpers
    var makeAnnotation;// = annotationFactory(options.elements.container, '.annotator-hl');

    function dispatchEvent(){
        options.elements.container.dispatchEvent(new CustomEvent('lgntoann.annotation.create', {detail: { tool : sessionStorage['lgnto.anntool'] || quickActionEvents[this.id], ann : anns['new']}}));//(this.toolsConfig[this.currTool].quickAction.event));
    };

    function registerAnnotations(annotations){
        annotations.forEach(a => {
            if(toolsConfig[a.type]){
                anns[a.id] = getAnnForPlugin(a);
            }
        });
    }

    function unregisterAnnotations(annotations){
        annsToDraw = [];
        annotations.forEach(a => {
            annsToDraw.push(anns[a.id]);
            delete anns[a.id];
        });
    }

    function getAnnForPlugin(ann){
        return Object.assign({}, legantoUtil.getAnnForPlugin(ann));
    }
    var anns = {};
    var annsToDraw = [];

    function getAnnById(annId){
        return annId ? (anns[annId] || anns['new']) : anns['new'];
    }
    
    function getHighlightObject(hlClassName){
        return new window['annotator'].ui.highlighter.Highlighter(options.elements.container, { highlightClass : hlClassName});
    }

    quickActionEvents = {};
    var legantoUtil = getAnnotationLegantoUtil.get();

    toolsConfig = {};
    function initTools(tools){
        for(t in tools){
            if(tools[t].legantoAnnotator){
                toolsConfig[t] = {};
                toolsConfig[t].config = tools[t];
            }
        }
    }
    
    function addAttr(ann, attr, val){
        if(ann && ann._local) $(ann._local.highlights).attr(attr, val ? val : "");
    }
    function removeAttr(ann, attr){
        if(ann && ann._local) $(ann._local.highlights).removeAttr(attr);
    }

    function draw(ann, state){
        var marker = toolsConfig[ann.type][state];
        if(marker) {
            marker['draw'](ann);
            $(ann._local.highlights).attr('visibility', ann.visibility);
            legantoUtil.addOffset(ann);
        }
    }
    function undraw(ann, state){
        if(!ann) return;
        var marker = toolsConfig[ann.type][state];
        if(marker) marker['undraw'](ann);
    }

    function cleanSelectedText(){
        if(selectedText){
            s.selectedText.undraw(selectedText);
            selectedText = undefined;
        }
    }

    function unhover(annId){
        removeAttr(anns[annId], 'hover');
    }

    function hover(annId){
        let ann = getAnnById(annId)
        if(!ann) return;
        addAttr(ann, 'hover');
    }

    function unselect(annId){
        removeAttr(getAnnById(annId), 'selected');
    }

    function select(annId){
        ann = getAnnById(annId);
        if(!ann) return;
        addAttr(ann, 'selected');
        options.elements.scrollToAnnotation(ann._local.highlights, ann);
    }

    function scroll(annId){
        ann = getAnnById(annId);
        if(!ann) return;
        options.elements.scrollToAnnotation(ann._local.highlights, ann);
    }

    function isToolConfigured(ann) {
        let tool = ann ? ann.type : sessionStorage['lgnto.anntool'];
        return  !tool || toolsConfig[tool];
    }

    function setAllMarkers(){
        for(t in toolsConfig){
            toolsConfig[t]['save'] = getHighlightObject(toolsConfig[t].config.className);
        }
        s.selectedText = getHighlightObject('selected-txt');
    }

    function deleteNewAnnotation(){
        var newAnn = anns['new'];
        if(newAnn){
            if(newAnn._local && newAnn.type){
                undraw(newAnn, 'save');
            }
            delete anns['new'];
        }
    }
    var selectedText;
//////////////////////////////////////////////////////////////////////////////////////////////////
    return {
        config : function(elementsConfig){
            sessionStorage.removeItem('lgnto.newannotation');
            sessionStorage.removeItem('lgnto.anntool');
            sessionStorage.removeItem('lgnto.anntoolAttributes');
            sessionStorage.removeItem("lgnto.fileRotation")
            delete anns['new']; // ?
        //options hold element and config 
            options.elements = elementsConfig;
            
            $(options.elements.find('fileContant')).on('scroll', undefined, undefined, legantoUtil.hideFloatMenus);
            //annotationFactory thired party function that will tell us what annototion we drow
            //and what annottation to ignor in case of more then 1 annotation on same text
            makeAnnotation = annotationFactory(options.elements.container, '.annotator-comment,.annotator-shape,.highlighted-txt');
            setAllMarkers();
            let textSelectorElement = options.elements.find('file');
            s.textselector = new window['annotator'].ui.textselector.TextSelector(textSelectorElement, {
                onSelection: function (ranges, event) {
                    cleanSelectedText();
                    legantoUtil.hideTrash();
                    
                    if(ranges.length == 0 || s.adder.isShown()) {
                        s.adder.hide();
                        if(s.adder.isShown()) window.getSelection().empty();
                        return;
                    }
                    
                    options.elements.container.dispatchEvent(new CustomEvent('lgntoann.selection.new'));
                    var annotation = makeAnnotation(ranges);
                    s.interactionPoint = window['annotator'].util.mousePosition(event);
                    sessionStorage['lgnto.newannotation'] = JSON.stringify(annotation);
                    deleteNewAnnotation();                    
                    anns['new'] = annotation;
					legantoUtil.addOffset(annotation);


                    //in case we selected action we whant to open the action
                    //else we open the menu
                    if(sessionStorage['lgnto.anntool']) dispatchEvent();
                    else {
                        selectedText = annotation;
                        s.selectedText.draw(selectedText);
                        s.adder.load(annotation, s.interactionPoint);
                    }
                }
            });
        },
        start : function(app){
            initTools(options.tools);
            quickActionEvents = legantoUtil.initQuickAction(options.htmlTemplate, toolsConfig, s, dispatchEvent);
            return true;
        },
        save : function(annId){
            ann = getAnnById(annId);
            if(!isToolConfigured(ann)) return;
            if(!ann) return;
            
            cleanSelectedText();

            (ann._local && ann._local.highlights) ? removeAttr(ann, 'edit') : draw(ann, 'save');

            if(!anns[annId] && anns['new']){
                anns[annId] = anns['new'];
                anns[annId].id = annId;
                delete anns['new'];
                legantoUtil.handleNewAnn(anns[annId], toolsConfig[ann.type].config, options.elements);
            }
        },
        edit : function(annId, cb){
            //get by id or get NEW annot
            let ann = getAnnById(annId);
            //check if the annot is form the typr of the plugin becouse it run the annot
            //on all plugins  we whant to save only for one 
            if(!isToolConfigured(ann) || !ann) return;
            if(!annId) {
                //clean blue span text
                cleanSelectedText();
                //draw the line
                draw(ann, 'save');
            }
            //add edit att will change the line to dotted line
            addAttr(ann, 'edit');
            if(cb) cb();
        },
        select : select,
        unselect : unselect,
        hover : hover,
        unhover : unhover,
        scroll : scroll,
        delete : function(annId){
            ann = getAnnById(annId);
            if(!ann || !isToolConfigured(ann)) return;
            // if(toolsConfig[ann.type].config.showTrash) detachTrashEvent(ann, annId);
            undraw(ann, 'save');
            annId ? delete anns[annId] : anns['new'];
        },
        reset : function(cb){
            if(!anns) return;
            for(var aId in anns){
                undraw(anns[aId], 'save');
            };
            setTimeout(function(){
                anns = {};
                if(cb) cb();
            }, 0);
        },
        load : function(annArr){
            if(!annArr || annArr.length == 0) return;
            registerAnnotations(annArr);
            annArr.forEach(a => {
                if(!anns[a.id]) return;
                if(a.id !== 'new'){
                    draw(anns[a.id], 'save');
                    legantoUtil.handleLoadedAnn(anns[a.id], toolsConfig[a.type].config, options.elements);
                }else{
                    this.edit();
                }
            });
        },
        deleteAll : function(annArr){
            if(!anns) return;
            for(var id in anns){
                this.delete(id);
            };
        },
        deleteAllComments : function(){
            if(!anns) return;
            for(var id in anns){
                if(toolsConfig[anns[id].type].config.attachComment){
                    this.delete(id);
                }
            };
        },
        selectTool : function(newTool){
            deleteNewAnnotation();
            s.adder.hide();
        },
        removeAllByConfig : function(annsConfig){
        	legantoUtil.runForAllByConfig(annsConfig, annId => {
        		if(anns[annId]){
            		undraw(anns[annId], 'save');
            		delete anns[annId];
        		}
        	});
	        return true;
        },
        disable : function(toolsCode){
            legantoUtil.disableTools(toolsCode, toolsConfig);
        }
    }
}